export default {
  name: 'AppLayout',
  data: function data() {
    return {};
  },
  components: {},
  methods: {
    scrollEvent: function scrollEvent(e) {
      var dis = e.srcElement.scrollTop;
      var self = this;
      if (dis > 150) {
        self.$store.dispatch('setScrollFlag', true);
      } else {
        self.$store.dispatch('setScrollFlag', false);
      }
    }
  }
};